import { useCallback, useEffect, useState } from 'react';

import { extractTrendUiErrorMessage } from '../errorUtils';
import { fetchTrendsOverview } from '../service';
import type { TrendsOverview } from '../types';

export function useTrendsOverview() {
  const [data, setData] = useState<TrendsOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await fetchTrendsOverview());
    } catch (err: any) {
      setError(extractTrendUiErrorMessage(err, 'Kunde inte ladda trendöversikten.'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { data, loading, error, reload };
}
